import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { AppSettings } from '../../../../../../proyect.conf';
import { TerceroUpPasarelaService } from '../../../../../_services/tercero-up-pasarela.service';
import { TerceroUpPasarelaProductoService } from '../../../../../_services/tercero-up-pasarela-producto.service';
import { TerceroUpPasarelaTarifaService } from '../../../../../_services/tercero-up-pasarela-tarifa.service';
import { TerceroUpPasarelaAdjuntoService } from '../../../../../_services/tercero-up-pasarela-adjunto.service';
import { TerceroUpPasarelaContratoService } from '../../../../../_services/tercero-up-pasarela-contrato.service';
import { AdministradorDocumentoService } from '../../../../../_services/administrador-documento.service';
import { AdjuntoService } from '../../../../../_services/adjunto.service';
import { PlantillaService } from '../../../../../_services/plantilla.service';
import { PlantillaVersionService } from '../../../../../_services/plantilla-version.service';
import { NavService } from '../../../../../_services/_nav.service';
import { ListaService } from '../../../../../_services/lista.service';
import { TerceroUPPasarela } from '../../../../../_models/tercero-up-pasarela';
import { TerceroUPPasarelaProducto } from '../../../../../_models/tercero-up-pasarela-producto';
import { TerceroUPPasarelaTarifa } from '../../../../../_models/tercero-up-pasarela-tarifa';
import { TerceroUPPasarelaAdjunto } from '../../../../../_models/tercero-up-pasarela-adjunto';
import { TerceroUPPasarelaContrato } from '../../../../../_models/tercero-up-pasarela-contrato';
import { AdministradorDocumento } from '../../../../../_models/administrador-documento';
import {
  AdmsbCanalNodo,
  AdmsbMedioFila,
  AdmsbMetodoNodo,
  AdmsbServicioNodo
} from '../../../../../_models/admsb-arbol';
import { InfoCanalPasarelaDTO, InfoServicioPasarelaDTO } from '../../../../../_models/info-canales-pasarelas.dto';
import { claseEstadoAdjunto, estadoAdjunto, filtrarPorTexto } from '../../admsb-titular.helpers';
import { EstadosMetodosMedios } from '../../../../../_enums/enum';
import { ListaItem } from '../../../../../_models/lista-item';

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

@Component({
  selector: 'app-admsb-servicio-arbol',
  templateUrl: './admsb-servicio-arbol.component.html',
  styleUrls: ['./admsb-servicio-arbol.component.scss'],
})
export class AdmsbServicioArbolComponent implements OnInit {

  @Input() idTitular: string;

  cargando = true;
  servicios: AdmsbServicioNodo[] = [];

  // URLs de carga de adjuntos
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  svcThUrlTercero = AppSettings.rutServiciosTER + '/api/adjuntosTerceros';

  // Control de subida de archivos
  private adjuntosCargando = new Set<string>();
  subAdjunto = false;
  private nomArchivoAdjunto = '';

  // Visor de adjunto
  showModalAdjunto = false;
  loadingFile = false;
  fileUrl: SafeResourceUrl = null;
  private archivoAdjuntoVisor: Blob | null = null;
  private nombreArchivoAdjuntoVisor = '';
  adjuntoVisor: TerceroUPPasarelaAdjunto | null = null;

  // Modal agregar documento
  mostrarModalAgregarAdjunto = false;
  submittedAdjunto = false;
  guardandoAdjunto = false;
  idDocumentoAdjuntoSeleccionado: string | null = null;
  documentosDisponibles: SelectItem[] = [];
  private documentosAdjuntos: SelectItem[] = [];
  private documentosAdjuntosCrudo: AdministradorDocumento[] = [];
  private metodoSeleccionadoParaAdjunto: AdmsbMetodoNodo | null = null;

  // Modal visualización de contrato
  mostrarModalContrato = false;
  contenidoContrato: SafeHtml | null = null;

  // Modal Gestión de Aprobación (HU #5354)
  mostrarModalAprobacion = false;
  medioParaAprobacion: AdmsbMedioFila | null = null;
  metodoParaAprobacion: AdmsbMetodoNodo | null = null;
  certificadoParaAprobacion: TerceroUPPasarelaAdjunto | null = null;
  private adjuntoPendienteAprobacion: TerceroUPPasarelaAdjunto | null = null;
  guardandoAprobacion = false;
  idEstadoActivo: string | null = null;
  listaEstadosMedio: ListaItem[] | null = null;
  listaEstadosServicio: ListaItem[] | null = null;
  private metodosCrudo: TerceroUPPasarelaProducto[] = [];
  private canalesCrudo: InfoCanalPasarelaDTO[] = [];

  // Modal Bloqueo (HU #5352)
  mostrarModalBloqueo = false;
  tipoBloqueo: 'SERVICIO' | 'METODO' | 'MEDIO' | null = null;
  servicioParaBloqueo: AdmsbServicioNodo | null = null;
  metodoParaBloqueo: AdmsbMetodoNodo | null = null;
  medioParaBloqueo: AdmsbMedioFila | null = null;
  idCausalBloqueoSeleccionada: string | null = null;
  comentarioBloqueo = '';
  submittedBloqueo = false;
  guardandoBloqueo = false;
  cargandoCausalesBloqueo = false;
  errorCausalesBloqueo = false;
  causalesBloqueoCrudo: any[] = [];
  idEstadoBloqueado: string | null = null;

  // Sidebar Gestionar Tarifas (HU #5353) - Delegado a AdmsbTarifasComponent
  mostrarSidebarTarifas = false;
  medioTarifasSeleccionado: AdmsbMedioFila | null = null;
  metodoTarifasSeleccionado: AdmsbMetodoNodo | null = null;

  estadosMetodosMedios = EstadosMetodosMedios;

  // Helpers exportados al template
  estadoAdjunto = estadoAdjunto;
  claseEstadoAdjunto = claseEstadoAdjunto;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private navService: NavService,
    private confirmService: ConfirmationService,
    private terceroUpPasarelaService: TerceroUpPasarelaService,
    private terceroUpPasarelaProductoServicio: TerceroUpPasarelaProductoService,
    private terceroUpPasarelaTarifaServicio: TerceroUpPasarelaTarifaService,
    private terceroUpPasarelaAdjuntoServicio: TerceroUpPasarelaAdjuntoService,
    private terceroUpPasarelaContratoServicio: TerceroUpPasarelaContratoService,
    private administradorDocumentoService: AdministradorDocumentoService,
    private adjService: AdjuntoService,
    private plantillaServicio: PlantillaService,
    private plantillaVersionServicio: PlantillaVersionService,
    private listaService: ListaService,
  ) {}

  ngOnInit(): void {
    this.cargarCatalogoDocumentos();
    this.cargarEstadosPasarela();
    this.cargarCausalesBloqueo();
    if (this.idTitular) {
      this.cargarArbol(this.idTitular);
    } else {
      this.cargando = false;
    }
  }

  private cargarEstadosPasarela(): void {
    this.listaService.getMasterDetails('ListasEstadosPasarela').subscribe({
      next: (res: any[]) => {
        const activo = (res || []).find(e => e.codigo === 'ITM00');
        if (activo) {
          this.idEstadoActivo = activo.idLista || activo.id;
        }
        const bloqueado = (res || []).find(e => e.codigo === 'ITM002');
        if (bloqueado) {
          this.idEstadoBloqueado = bloqueado.idLista || bloqueado.id;
        }
      },
      error: () => {}
    });

    this.listaService.getMasterDetails('ListasEstadosMediosPasarela').subscribe({
      next: (res: any[]) => {
       this.listaEstadosMedio = res;
      },
      error: () => {}
    });

    this.listaService.getMasterDetails('ListasEstadosServicios').subscribe({
      next: (res: any[]) => {
        this.listaEstadosServicio = res;
      },
      error: () => {}
    });
  }

  private obtenerIdEstadoServicio(codigo: string): string | null {
    if (!this.listaEstadosServicio || this.listaEstadosServicio.length === 0) {
      return null;
    }
    const codUpper = (codigo || '').toUpperCase();
    const item = this.listaEstadosServicio.find(x => {
      const itemCod = (x.codigo || '').toUpperCase();
      if (itemCod === codUpper) {
        return true;
      }
      if (codUpper === 'SERACT' && (itemCod === 'ACTIVO' || itemCod === 'ACT')) {
        return true;
      }
      if (codUpper === 'SERBLO' && (itemCod === 'BLOQUEADO' || itemCod === 'BLOQ' || itemCod === 'BLO')) {
        return true;
      }
      return false;
    });
    return item ? (item.idLista || (item as any).id || null) : null;
  }

  private obtenerIdEstadoServicio$(codigo: string): Observable<string | null> {
    if (this.listaEstadosServicio && this.listaEstadosServicio.length > 0) {
      return of(this.obtenerIdEstadoServicio(codigo));
    }
    return this.listaService.getMasterDetails('ListasEstadosServicios').pipe(
      map((res: any[]) => {
        this.listaEstadosServicio = res || [];
        return this.obtenerIdEstadoServicio(codigo);
      }),
      catchError(() => of(null))
    );
  }

  cargarCausalesBloqueo(): void {
    this.cargandoCausalesBloqueo = true;
    this.errorCausalesBloqueo = false;
    this.listaService.getMasterDetails('ListasCausalesBloqueosMetodosMedios').subscribe({
      next: (res: any) => {
        this.cargandoCausalesBloqueo = false;
        if (Array.isArray(res) && res.length > 0) {
          this.causalesBloqueoCrudo = res;
          this.errorCausalesBloqueo = false;
        } else {
          this.causalesBloqueoCrudo = [];
          this.errorCausalesBloqueo = true;
        }
        this.actualizarCausalesBloqueoOpciones();
      },
      error: () => {
        this.cargandoCausalesBloqueo = false;
        this.causalesBloqueoCrudo = [];
        this.errorCausalesBloqueo = true;
        this.actualizarCausalesBloqueoOpciones();
      }
    });
  }

  private cargarCatalogoDocumentos(): void {
    this.administradorDocumentoService.getAllEnable().subscribe({
      next: (res) => {
        this.documentosAdjuntosCrudo = res || [];
        this.documentosAdjuntos = (res || []).map((d: AdministradorDocumento) => ({
          label: d.nombre,
          value: d.idDocumentoTercero
        }));
      },
      error: () => {
        this.documentosAdjuntosCrudo = [];
        this.documentosAdjuntos = [];
      }
    });
  }

  cargarArbol(idTerceroUPPasarela: string): void {
    this.cargando = true;

    forkJoin([
      this.terceroUpPasarelaProductoServicio.obtenerInfoServicioPasarelas(idTerceroUPPasarela).pipe(catchError(() => of({} as InfoServicioPasarelaDTO))),
      this.terceroUpPasarelaAdjuntoServicio.listAdjuntos(idTerceroUPPasarela).pipe(catchError(() => of([]))),
      this.terceroUpPasarelaContratoServicio.listPasarelasContratos(idTerceroUPPasarela).pipe(catchError(() => of([]))),
    ]).subscribe({
      next: ([servicioDTO, adjuntosCrudo, contratosCrudo]) => {
        this.canalesCrudo = servicioDTO.canalesPasarelasResponseDTO || [];

        // Mantener metodosCrudo aplanados para compatibilidad de acciones existentes (bloqueo / aprobación)
        const metodosAplanados: any[] = [];
        this.canalesCrudo.forEach(c => {
          (c.metodos || []).forEach(m => {
            metodosAplanados.push({
              idTerceroUPPasarelaProducto: m.idTerceroUPPasarelaProducto || m.idMetodo,
              idProductoPasarela: m.idMetodo,
              codigoMetodoLista: m.codigoMetodo,
              nombreMetodoLista: m.nombreMetodo,
              idEstadoPasarela: m.idEstadoPasarela,
              codigoEstadoPasarela: m.codigoEstadoMetodo || (m.estadoMetodo === 'ACTIVA' ? 'ITM00' : 'ITM004'),
              nombreEstadoPasarela: m.estadoMetodo,
              indicadorHabilitado: m.estadoMetodo === 'ACTIVA' || m.codigoEstadoMetodo === 'ITM00'
            });
          });
        });
        this.metodosCrudo = metodosAplanados;

        this.construirArbol(this.canalesCrudo, adjuntosCrudo || [], contratosCrudo || [], servicioDTO);
        this.cargando = false;
      },
      error: () => {
        this.servicios = [];
        this.cargando = false;
      }
    });
  }

  private construirArbol(
    canalesDTO: InfoCanalPasarelaDTO[],
    adjuntos: TerceroUPPasarelaAdjunto[],
    contratos: TerceroUPPasarelaContrato[],
    servicioDTO?: InfoServicioPasarelaDTO
  ): void {
    let todosMetodosActivos = 0;
    let todosMetodosTotal = 0;
    let todosMediosActivos = 0;
    let todosMediosTotal = 0;

    const canales: AdmsbCanalNodo[] = (canalesDTO || []).map((c, idx) => {
      const metodosDelCanal: AdmsbMetodoNodo[] = (c.metodos || []).map(m => {
        const mediosFilas: AdmsbMedioFila[] = (m.medios || []).map(med => ({
          ...med,
          idMedioPago: med.idMedio,
          nombreMedioPago: med.nombreMedio,
          codigoMedioPago: med.codigoMedio,
          comisionVentaPorcentaje: med.tarifaTrxVentaPorcentaje ?? 0,
          ventaMinima: med.montoMinimoTrx ?? 0,
          ventaMaxima: med.montoMaximoTrx ?? 0,
          limiteDiaRecaudos: med.limiteTrxDiario ?? 0,
          limiteMesRecaudos: med.limiteTrxMes ?? 0,
          limiteMesMonto: med.montoMaximoMes ?? 0,
          estado: med.estadoMedio,
          codigoEstado: med.codigoEstadoMedio,
          indicadorHabilitado: med.codigoEstadoMedio === EstadosMetodosMedios.MEDIOACTIVO,
          idAdjuntoCertificadoRegistro: med.idAdjuntoCertificadoRegistroMedio || med.idAdjuntoCertificadoRegistro || null,
          raw: med
        }));

        const mediosActivos = m.totalMediosActivos ?? mediosFilas.filter(med => med.codigoEstadoMedio === EstadosMetodosMedios.MEDIOACTIVO).length;
        const totalMedios = m.totalMedios ?? mediosFilas.length;

        todosMediosActivos += mediosActivos;
        todosMediosTotal += totalMedios;

        const esMetodoActivo = m.codigoEstadoMetodo === EstadosMetodosMedios.METODOACTIVO;

        return {
          ...m,
          idProductoPasarela: m.idMetodo,
          estado: m.estadoMetodo,
          codigoEstado: m.codigoEstadoMetodo,
          indicadorHabilitado: esMetodoActivo,
          mediosHabilitadosCount: mediosActivos,
          mediosTotalCount: totalMedios,
          idAdjuntoCertificadoRegistro: m.idAdjuntoCertificadoRegistroMetodo || m.idAdjuntoCertificadoRegistro || null,
          abierto: true,
          medios: mediosFilas,
          adjuntos: [...adjuntos],
          contratos: [...contratos],
          filtroAdjuntos: '',
          filtroContratos: ''
        };
      });

      const metodosActivosCanal = c.totalMetodosActivos ?? metodosDelCanal.filter(met => met.codigoEstadoMetodo === EstadosMetodosMedios.METODOACTIVO).length;
      const metodosTotalCanal = c.totalMetodos ?? metodosDelCanal.length;

      todosMetodosActivos += metodosActivosCanal;
      todosMetodosTotal += metodosTotalCanal;

      return {
        ...c,
        ordenCanal: idx + 1,
        metodosActivosCount: metodosActivosCanal,
        metodosTotalCount: metodosTotalCanal,
        abierto: true,
        metodos: metodosDelCanal
      };
    });

    // Calcular fecha de activación (si hay contratos firmados o fecha actual)
    const todasFechas: number[] = [];
    contratos.forEach(c => { if (c.fechaFirma) todasFechas.push(new Date(c.fechaFirma).getTime()); });

    let fechaActivacionStr: string = null;
    if (todasFechas.length > 0) {
      const fechaMin = new Date(Math.min(...todasFechas.filter(d => !isNaN(d))));
      if (!isNaN(fechaMin.getTime())) {
        fechaActivacionStr = this.formatearFecha(fechaMin);
      }
    }

    const servicio: AdmsbServicioNodo = {
      idServicio: servicioDTO?.idServicio || 'SERV_01',
      nombreServicio: servicioDTO?.servicio || 'Servicio Recaudo',
      codigoServicio: servicioDTO?.codigoEstadoServicio || 'SERREC',
      estadoServicio: servicioDTO?.codigoEstadoServicio || 'SERACT',
      codigoEstadoServicio: servicioDTO?.codigoEstadoServicio || 'SERACT',
      idEstadoServicio: (servicioDTO as any)?.idEstadoServicio || null,
      fechaActivacion: servicioDTO?.fechaActivacion || fechaActivacionStr || this.formatearFecha(new Date()),
      metodosActivosCount: todosMetodosActivos,
      metodosTotalCount: todosMetodosTotal > 0 ? todosMetodosTotal : 1,
      mediosActivosCount: todosMediosActivos,
      mediosTotalCount: todosMediosTotal > 0 ? todosMediosTotal : 1,
      abierto: true,
      canales: canales
    };

    this.servicios = [servicio];
  }

  formatearFecha(dateInput: string | Date): string {
    if (!dateInput) return '--';
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return String(dateInput);
    const dia = d.getDate();
    const mes = MESES[d.getMonth()] || '';
    const anio = d.getFullYear();
    return `${dia < 10 ? '0' + dia : dia} ${mes} ${anio}`;
  }

  // ---- Acordeones ----
  toggleServicio(servicio: AdmsbServicioNodo): void {
    servicio.abierto = !servicio.abierto;
  }

  toggleCanal(canal: AdmsbCanalNodo): void {
    canal.abierto = !canal.abierto;
  }

  toggleMetodo(metodo: AdmsbMetodoNodo): void {
    metodo.abierto = !metodo.abierto;
  }

  // ---- Acciones con stubs de HU asociadas ----
  get tituloModalBloqueo(): string {
    if (this.tipoBloqueo === 'SERVICIO') {
      return this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.TITULO_MODAL_BLOQUEAR_SERVICIO') || 'BLOQUEAR SERVICIO';
    }
    if (this.tipoBloqueo === 'METODO') {
      return this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.TITULO_MODAL_BLOQUEAR_METODO') || 'BLOQUEAR MÉTODO DE PAGO';
    }
    return this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.TITULO_MODAL_BLOQUEAR_MEDIO') || 'BLOQUEAR MEDIO DE PAGO';
  }

  causalesBloqueoOpciones: SelectItem[] = [];

  actualizarCausalesBloqueoOpciones(): void {
    if (!this.causalesBloqueoCrudo || !Array.isArray(this.causalesBloqueoCrudo) || this.causalesBloqueoCrudo.length === 0) {
      this.causalesBloqueoOpciones = [];
      return;
    }
    const filtradas = this.causalesBloqueoCrudo.filter(item => {
      const codigo = (item.codigo || '').toUpperCase();
      if (this.tipoBloqueo === 'SERVICIO') {
        return codigo.startsWith('SV') || (!codigo.startsWith('MD') && !codigo.startsWith('MT'));
      }
      if (this.tipoBloqueo === 'MEDIO') {
        return codigo.startsWith('MD') || (!codigo.startsWith('MD') && !codigo.startsWith('MT'));
      }
      if (this.tipoBloqueo === 'METODO') {
        return codigo.startsWith('MT') || (!codigo.startsWith('MD') && !codigo.startsWith('MT'));
      }
      return true;
    });

    this.causalesBloqueoOpciones = filtradas.map(c => ({
      label: c.nombre || c.label || c.codigo,
      value: c.idLista || c.value || c.codigo
    }));
  }

  private toastExito(detail: string): void {
    this.navService.setMesageToast({
      severity: 'success',
      summary: this.navService.buscarMensaje('LBL_CONFIRMACION') || 'Éxito',
      detail
    });
  }

  private abrirModalBloqueo(
    tipo: 'SERVICIO' | 'METODO' | 'MEDIO',
    contexto: { servicio?: AdmsbServicioNodo; metodo?: AdmsbMetodoNodo; medio?: AdmsbMedioFila }
  ): void {
    this.tipoBloqueo = tipo;
    this.servicioParaBloqueo = contexto.servicio || null;
    this.metodoParaBloqueo = contexto.metodo || null;
    this.medioParaBloqueo = contexto.medio || null;
    this.idCausalBloqueoSeleccionada = null;
    this.comentarioBloqueo = '';
    this.submittedBloqueo = false;
    this.guardandoBloqueo = false;
    this.actualizarCausalesBloqueoOpciones();
    this.mostrarModalBloqueo = true;
    if (!this.causalesBloqueoCrudo || this.causalesBloqueoCrudo.length === 0) {
      this.cargarCausalesBloqueo();
    }
  }

  bloquearServicio(servicio: AdmsbServicioNodo): void {
    this.abrirModalBloqueo('SERVICIO', { servicio });
  }

  desbloquearServicio(servicio: AdmsbServicioNodo): void {
    if (!servicio) {
      return;
    }

    const consulta$ = this.idTitular
      ? forkJoin([
          this.terceroUpPasarelaService.obtener(this.idTitular),
          this.obtenerIdEstadoServicio$('SERACT')
        ]).pipe(
          switchMap(([pasarela, idEstadoServicio]) => {
            const idEstadoServicioFinal = idEstadoServicio || pasarela?.idEstadoServicio;
            const pasarelaActualizada: TerceroUPPasarela = {
              ...pasarela,
              indicadorHabilitado: true,
              idEstadoServicio: idEstadoServicioFinal,
              codigoEstadoServicio: 'SERACT',
              estadoServicio: 'ACTIVO'
            };
            return this.terceroUpPasarelaService.actualizar(pasarelaActualizada).pipe(
              map(() => ({ idEstadoServicio: idEstadoServicioFinal }))
            );
          })
        )
      : of(null);

    this.cargando = true;
    consulta$.subscribe({
      next: (res: any) => {
        servicio.codigoEstadoServicio = 'SERACT';
        servicio.estadoServicio = 'SERACT';
        if (res?.idEstadoServicio) {
          servicio.idEstadoServicio = res.idEstadoServicio;
        }
        this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_SERVICIO_DESBLOQUEADO_EXITO') || 'Servicio desbloqueado correctamente');
        if (this.idTitular) {
          this.cargarArbol(this.idTitular);
        } else {
          this.cargando = false;
        }
      },
      error: () => {
        this.cargando = false;
        this.navService.setMesage(3);
      }
    });
  }

  bloquearMetodo(metodo: AdmsbMetodoNodo): void {
    this.abrirModalBloqueo('METODO', { metodo });
  }

  bloquearMedio(medio: AdmsbMedioFila, metodo?: AdmsbMetodoNodo): void {
    this.abrirModalBloqueo('MEDIO', { medio, metodo });
  }

  cerrarModalBloqueo(): void {
    this.mostrarModalBloqueo = false;
    this.tipoBloqueo = null;
    this.servicioParaBloqueo = null;
    this.metodoParaBloqueo = null;
    this.medioParaBloqueo = null;
    this.idCausalBloqueoSeleccionada = null;
    this.comentarioBloqueo = '';
    this.submittedBloqueo = false;
    this.guardandoBloqueo = false;
    this.causalesBloqueoOpciones = [];
  }

  private obtenerTarifaBaseParaActualizacion$(medio: AdmsbMedioFila): Observable<TerceroUPPasarelaTarifa> {
    const idProductoPasarelaTarifa = medio?.idProductoPasarelaTarifa || medio?.raw?.idProductoPasarelaTarifa;
    const fallback = (medio?.raw || medio || {}) as TerceroUPPasarelaTarifa;
    if (!this.idTitular || !idProductoPasarelaTarifa) {
      return of(fallback);
    }
    return this.terceroUpPasarelaTarifaServicio.obtenerTercerosUPPasarelasTarifas(this.idTitular, idProductoPasarelaTarifa).pipe(
      map(res => res || fallback),
      catchError(() => of(fallback))
    );
  }

  private actualizarEstadoMedio(
    medio: AdmsbMedioFila,
    metodo: AdmsbMetodoNodo | null,
    cambios: Partial<TerceroUPPasarelaTarifa> & Record<string, any>
  ): Observable<TerceroUPPasarelaTarifa> {
    return this.obtenerTarifaBaseParaActualizacion$(medio).pipe(
      switchMap((tarifaActual) => {
        const registroMedio: TerceroUPPasarelaTarifa = {
          ...tarifaActual,
          //idTerceroUPPasarelaProducto: metodo?.idTerceroUPPasarelaProducto || tarifaActual?.idTerceroUPPasarelaProducto || medio?.idTerceroUPPasarelaTarifa || medio?.raw?.idTerceroUPPasarelaProducto,
          ...cambios
        };
        return this.terceroUpPasarelaTarifaServicio.guardarPasarelaVersion(registroMedio);
      })
    );
  }

  guardarBloqueo(): void {
    this.submittedBloqueo = true;
    if (this.causalesBloqueoOpciones.length === 0) {
      this.navService.setMesageToast({
        severity: 'warn',
        summary: this.navService.buscarMensaje('LBL_ADVERTENCIA') || 'Advertencia',
        detail: this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_ERROR_CAUSALES_NO_DISPONIBLES') || 'El servicio de causales de bloqueo no respondió. Por favor reintente la carga.'
      });
      return;
    }

    if (!this.tipoBloqueo) {
      return;
    }

    if (!this.idCausalBloqueoSeleccionada || !this.comentarioBloqueo || !this.comentarioBloqueo.trim() || this.guardandoBloqueo) {
      return;
    }

    if (this.comentarioBloqueo.length > 500) {
      return;
    }

    this.guardandoBloqueo = true;

    if (this.tipoBloqueo === 'MEDIO') {
      const medio = this.medioParaBloqueo;
      if (!medio) {
        this.guardandoBloqueo = false;
        return;
      }

      const idListaEstadoBloqueado = this.listaEstadosMedio?.find(x =>
        x.codigo === 'MEDBLO' || x.codigo === 'BLOQUEADO'
      )?.idLista || null;

      this.actualizarEstadoMedio(medio, this.metodoParaBloqueo, {
        indicadorHabilitado: false,
        codigoEstadoMedio: 'MEDBLO',
        estadoMedio: 'BLOQUEADO',
        idEstadoMedioPago: idListaEstadoBloqueado,
        //IdEstadoMedioPago: idListaEstadoBloqueado,
        idCausal: this.idCausalBloqueoSeleccionada,
        comentario: this.comentarioBloqueo.trim()
      }).subscribe({
        next: (respTarifa: any) => {
          this.guardandoBloqueo = false;
          this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_MEDIO_BLOQUEADO_EXITO'));
          medio.estado = 'BLOQUEADO';
          medio.codigoEstado = 'MEDBLO';
          medio.estadoMedio = 'BLOQUEADO';
          medio.codigoEstadoMedio = 'MEDBLO';
          medio.indicadorHabilitado = false;
          medio.idEstadoMedioPago = idListaEstadoBloqueado;
          medio.IdEstadoMedioPago = idListaEstadoBloqueado;
          if (respTarifa) {
            medio.raw = { ...medio.raw, ...respTarifa, idEstadoMedioPago: idListaEstadoBloqueado, IdEstadoMedioPago: idListaEstadoBloqueado };
          }
          this.cerrarModalBloqueo();
          this.cargarArbol(this.idTitular);
        },
        error: () => {
          this.guardandoBloqueo = false;
          this.navService.setMesage(3);
        }
      });

    } else if (this.tipoBloqueo === 'METODO') {
      const metodo = this.metodoParaBloqueo;
      if (!metodo) {
        this.guardandoBloqueo = false;
        return;
      }

      const metodoRaw = this.metodosCrudo.find(m =>
        (m.idTerceroUPPasarelaProducto || m.codigoMetodoLista) === (metodo.idTerceroUPPasarelaProducto || metodo.codigoMetodo)
      );

      const registroMetodo: any = {
        ...(metodoRaw || {} as any),
        idTerceroUPPasarelaProducto: metodo.idTerceroUPPasarelaProducto,
        idTerceroUPPasarela: this.idTitular,
        idProductoPasarela: metodo.idProductoPasarela,
        idEstadoPasarela: this.idEstadoBloqueado || metodoRaw?.idEstadoPasarela,
        codigoEstadoPasarela: 'ITM002',
        nombreEstadoPasarela: 'BLOQUEADO',
        indicadorHabilitado: false,
        codigoMetodoLista: metodo.codigoMetodo,
        nombreMetodoLista: metodo.nombreMetodo,
        idCausal: this.idCausalBloqueoSeleccionada,
        comentario: this.comentarioBloqueo.trim()
      };

      this.terceroUpPasarelaProductoServicio.crearPasarelaVersion(registroMetodo).subscribe({
        next: () => {
          this.guardandoBloqueo = false;
          this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_METODO_BLOQUEADO_EXITO') || 'Método de pago bloqueado correctamente');
          metodo.codigoEstado = 'ITM002';
          metodo.estado = 'BLOQUEADO';
          metodo.codigoEstadoMetodo = 'ITM002';
          metodo.estadoMetodo = 'BLOQUEADO';
          metodo.indicadorHabilitado = false;
          this.cerrarModalBloqueo();
          this.cargarArbol(this.idTitular);
        },
        error: () => {
          this.guardandoBloqueo = false;
          this.navService.setMesage(3);
        }
      });

    } else if (this.tipoBloqueo === 'SERVICIO') {
      const servicio = this.servicioParaBloqueo;
      if (!servicio) {
        this.guardandoBloqueo = false;
        return;
      }

      const consulta$ = this.idTitular
        ? forkJoin([
            this.terceroUpPasarelaService.obtener(this.idTitular),
            this.obtenerIdEstadoServicio$('SERBLO')
          ]).pipe(
            switchMap(([pasarela, idEstadoServicio]) => {
              const idEstadoServicioFinal = idEstadoServicio || pasarela?.idEstadoServicio;
              const pasarelaActualizada: TerceroUPPasarela = {
                ...pasarela,
                indicadorHabilitado: false,
                idEstadoServicio: idEstadoServicioFinal,
                codigoEstadoServicio: 'SERBLO',
                estadoServicio: 'BLOQUEADO',
                idCausal: this.idCausalBloqueoSeleccionada,
                comentario: this.comentarioBloqueo.trim()
              };
              return this.terceroUpPasarelaService.actualizar(pasarelaActualizada).pipe(
                map(() => ({ idEstadoServicio: idEstadoServicioFinal }))
              );
            })
          )
        : of(null);

      consulta$.subscribe({
        next: (res: any) => {
          this.guardandoBloqueo = false;
          servicio.codigoEstadoServicio = 'SERBLO';
          servicio.estadoServicio = 'SERBLO';
          if (res?.idEstadoServicio) {
            servicio.idEstadoServicio = res.idEstadoServicio;
          }
          this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_SERVICIO_BLOQUEADO_EXITO') || 'Servicio bloqueado correctamente');
          this.cerrarModalBloqueo();
          if (this.idTitular) {
            this.cargarArbol(this.idTitular);
          }
        },
        error: () => {
          this.guardandoBloqueo = false;
          this.navService.setMesage(3);
        }
      });
    }
  }

  activarMedio(medio: AdmsbMedioFila, metodo?: AdmsbMetodoNodo): void {
    this.medioParaAprobacion = medio;
    this.metodoParaAprobacion = metodo || null;
    this.adjuntoPendienteAprobacion = null;
    const idAdjuntoExistente = medio?.idAdjuntoCertificadoRegistro || null;
    const nombreCert = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO');
    this.certificadoParaAprobacion = this.crearAdjuntoDesdeId(idAdjuntoExistente, nombreCert);
    this.guardandoAprobacion = false;
    this.mostrarModalAprobacion = true;
  }

  activarMetodo(metodo: AdmsbMetodoNodo): void {
    this.medioParaAprobacion = null;
    this.metodoParaAprobacion = metodo;
    this.adjuntoPendienteAprobacion = null;
    const idAdjuntoExistente = metodo?.idAdjuntoCertificadoRegistro || null;
    const nombreCert = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO');
    this.certificadoParaAprobacion = this.crearAdjuntoDesdeId(idAdjuntoExistente, nombreCert);
    this.guardandoAprobacion = false;
    this.mostrarModalAprobacion = true;
  }

  cerrarModalAprobacion(): void {
    this.mostrarModalAprobacion = false;
    this.medioParaAprobacion = null;
    this.metodoParaAprobacion = null;
    this.certificadoParaAprobacion = null;
    this.adjuntoPendienteAprobacion = null;
    this.guardandoAprobacion = false;
  }

  private crearCertificadoRegistroPlantilla(idDocumentoTercero: string, codigo: string, nombre: string): TerceroUPPasarelaAdjunto {
    const defaultNombre = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO');
    const defaultDesc = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_SUBTITULO_CERTIFICADO');
    return {
      idSolicitudUCRespaldoAdjunto: null,
      idRespaldo: null,
      indicadorEliminacionManual: null,
      idTerceroDocumentoTercero: null,
      idTercero: null,
      idDocumentoTercero,
      idSolicitudUCControlAdjunto: null,
      idProductoControl: null,
      indicadorConsulta: null,
      resultado: null,
      indicadorCalificacion: null,
      indicadorViabilidad: null,
      idAdjunto: null,
      idSolicitudUnidadCredito: null,
      indicadorRetoma: null,
      nombreAdjunto: null,
      descripcionAdjunto: defaultDesc,
      idProductoAdjunto: null,
      idProducto: null,
      codigo: codigo || 'CERTREG',
      nombre: nombre || defaultNombre,
      idTerceroUPPasarelaAdjunto: null,
      idTerceroUPPasarela: this.idTitular,
      idTercerosUPPasarelasAdjuntosVersion: null,
      orden: 1,
      indicadorObligatorio: null,
      codigoDocumento: null,
      codigoTipoVigencia: 'TEMPO',
      tipoVigencia: 'Verificable',
      documento: null,
      fechaAdjunto: null,
      indicadorTercero: false,
      indicadorVencido: null,
      indicadorSolicitarCliente: false
    };
  }

  private crearAdjuntoDesdeId(idAdjunto: string | null, nombre: string): TerceroUPPasarelaAdjunto {
    const defaultNombre = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO');
    const adj = this.crearCertificadoRegistroPlantilla('DOC_CERT_REG', 'CERTREG', nombre || defaultNombre);
    adj.idAdjunto = idAdjunto;
    return adj;
  }

  esCertificadoCargado(): boolean {
    return !!(
      this.certificadoParaAprobacion?.idAdjunto ||
      this.medioParaAprobacion?.idAdjuntoCertificadoRegistro ||
      this.metodoParaAprobacion?.idAdjuntoCertificadoRegistro
    );
  }

  estadoCertificado(): string {
    //const vigencia = this.certificadoParaAprobacion?.tipoVigencia;
    if (this.esCertificadoCargado()) {
      const txtCargado = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO_CARGADO');
      return  txtCargado;
    }
    const txtPendiente = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO_PENDIENTE');
    return  txtPendiente;
  }

  onUploadAdjuntoModal(event: any, adjunto: TerceroUPPasarelaAdjunto): void {
    const idAdjunto = event?.originalEvent?.body?.idAdjunto || event?.body?.idAdjunto;
    if (!idAdjunto || !adjunto) {
      if (adjunto?.idDocumentoTercero) {
        this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
      }
      this.subAdjunto = false;
      return;
    }
    adjunto.idAdjunto = idAdjunto;
    if (this.certificadoParaAprobacion) {
      this.certificadoParaAprobacion.idAdjunto = idAdjunto;
    }
    this.adjuntoPendienteAprobacion = adjunto;
    this.navService.setMesage(2);
    if (adjunto?.idDocumentoTercero) {
      this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
    }
    this.subAdjunto = false;

    if (this.metodoParaAprobacion?.adjuntos && !this.metodoParaAprobacion.adjuntos.some(a => a.idDocumentoTercero === adjunto.idDocumentoTercero)) {
      this.metodoParaAprobacion.adjuntos.push(adjunto);
    }
  }

  aprobarMedio(): void {
    if (!this.medioParaAprobacion || !this.esCertificadoCargado() || this.guardandoAprobacion) {
      return;
    }

    this.guardandoAprobacion = true;
    const metodo = this.metodoParaAprobacion;
    const medio = this.medioParaAprobacion;

    const idListaEstadoMedio = this.listaEstadosMedio?.find(x => x.codigo === EstadosMetodosMedios.MEDIOACTIVO)?.idLista || null;

    const idAdjuntoCert = this.certificadoParaAprobacion?.idAdjunto ||
      medio?.idAdjuntoCertificadoRegistro || null;

    this.actualizarEstadoMedio(medio, metodo, {
      indicadorHabilitado: true,
      codigoEstadoMedio: EstadosMetodosMedios.MEDIOACTIVO,
      estadoMedio: 'ACTIVO',
      idEstadoMedioPago: idListaEstadoMedio,
      IdEstadoMedioPago: idListaEstadoMedio,
      idAdjuntoCertificadoRegistro: idAdjuntoCert
    }).subscribe({
      next: (respTarifa) => {
        this.guardandoAprobacion = false;
        this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_MEDIO_APROBADO_EXITO'));
        medio.estado = 'ACTIVO';
        medio.codigoEstado = EstadosMetodosMedios.MEDIOACTIVO;
        medio.estadoMedio = 'ACTIVO';
        medio.codigoEstadoMedio = EstadosMetodosMedios.MEDIOACTIVO;
        medio.indicadorHabilitado = true;
        medio.idEstadoMedioPago = idListaEstadoMedio;
        medio.IdEstadoMedioPago = idListaEstadoMedio;
        medio.idAdjuntoCertificadoRegistro = idAdjuntoCert;
        if (respTarifa) {
          medio.raw = { ...medio.raw, ...respTarifa, idEstadoMedioPago: idListaEstadoMedio, IdEstadoMedioPago: idListaEstadoMedio };
        }
        this.cerrarModalAprobacion();
        this.cargarArbol(this.idTitular);
      },
      error: () => {
        this.guardandoAprobacion = false;
        this.navService.setMesage(3);
      }
    });
  }

  rechazarMedio(): void {
    if (!this.medioParaAprobacion || this.guardandoAprobacion) {
      return;
    }

    this.guardandoAprobacion = true;
    const medio = this.medioParaAprobacion;
    const metodo = this.metodoParaAprobacion;

    const idListaEstadoMedio = this.listaEstadosMedio?.find(x =>
      x.codigo === EstadosMetodosMedios.MEDIODENEGADO ||
      x.codigo === 'DENEGA' ||
      x.codigo === 'MEDDEN' ||
      x.codigo === 'DENEGADO'
    )?.idLista || null;

    this.actualizarEstadoMedio(medio, metodo, {
      indicadorHabilitado: false,
      codigoEstadoMedio: EstadosMetodosMedios.MEDIODENEGADO,
      estadoMedio: 'DENEGADO',
      idEstadoMedioPago: idListaEstadoMedio,
      IdEstadoMedioPago: idListaEstadoMedio
    }).subscribe({
      next: (respTarifa) => {
        this.guardandoAprobacion = false;
        this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_MEDIO_RECHAZADO_EXITO'));
        medio.estado = 'DENEGADO';
        medio.codigoEstado = EstadosMetodosMedios.MEDIODENEGADO;
        medio.estadoMedio = 'DENEGADO';
        medio.codigoEstadoMedio = EstadosMetodosMedios.MEDIODENEGADO;
        medio.indicadorHabilitado = false;
        medio.idEstadoMedioPago = idListaEstadoMedio;
        medio.IdEstadoMedioPago = idListaEstadoMedio;
        if (respTarifa) {
          medio.raw = { ...medio.raw, ...respTarifa, idEstadoMedioPago: idListaEstadoMedio, IdEstadoMedioPago: idListaEstadoMedio };
        }
        this.cerrarModalAprobacion();
        this.cargarArbol(this.idTitular);
      },
      error: () => {
        this.guardandoAprobacion = false;
        this.navService.setMesage(3);
      }
    });
  }

  aprobarMetodo(): void {
    if (!this.metodoParaAprobacion || !this.esCertificadoCargado() || this.guardandoAprobacion) {
      return;
    }

    this.guardandoAprobacion = true;
    const metodo = this.metodoParaAprobacion;
    const idAdjuntoCert = this.certificadoParaAprobacion?.idAdjunto ||
      metodo.idAdjuntoCertificadoRegistro || null;

    const idListaEstadoActivo = this.idEstadoActivo;
    const idProductoPasarela = metodo.idProductoPasarela;
    const metodoRaw = this.metodosCrudo.find(m =>
      (m.idTerceroUPPasarelaProducto || m.codigoMetodoLista) === (metodo.idTerceroUPPasarelaProducto || metodo.codigoMetodo)
    );

    const consulta$: Observable<TerceroUPPasarelaProducto> = (this.idTitular && idProductoPasarela)
      ? this.terceroUpPasarelaProductoServicio.obtenerTercerosPasarelaProductos(this.idTitular, idProductoPasarela).pipe(
          catchError(() => of(metodoRaw || ({} as TerceroUPPasarelaProducto)))
        )
      : of(metodoRaw || ({} as TerceroUPPasarelaProducto));

    consulta$.pipe(
      switchMap((prodExistente) => {
        const registroMetodo: TerceroUPPasarelaProducto = {
          id: prodExistente?.id || 0,
          idTercerosUPPasarelasProductosVersion: prodExistente?.idTercerosUPPasarelasProductosVersion || '',
          auditoriaFecha: null,
          auditoriaUsuario: null,
          ip: null,
          ...(prodExistente || {}),
          idTerceroUPPasarelaProducto: metodo.idTerceroUPPasarelaProducto || prodExistente?.idTerceroUPPasarelaProducto,
          idTerceroUPPasarela: this.idTitular,
          idProductoPasarela: idProductoPasarela || prodExistente?.idProductoPasarela,
          idEstadoPasarela: idListaEstadoActivo || prodExistente?.idEstadoPasarela,
          codigoEstadoPasarela: EstadosMetodosMedios.METODOACTIVO,
          nombreEstadoPasarela: 'ACTIVA',
          indicadorHabilitado: true,
          codigoMetodoLista: metodo.codigoMetodo || prodExistente?.codigoMetodoLista,
          nombreMetodoLista: metodo.nombreMetodo || prodExistente?.nombreMetodoLista,
          idAdjuntoCertificadoRegistro: idAdjuntoCert
        } as TerceroUPPasarelaProducto;
        return this.terceroUpPasarelaProductoServicio.crearPasarelaVersion(registroMetodo);
      })
    ).subscribe({
      next: () => {
        this.guardandoAprobacion = false;
        this.toastExito(this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_METODO_APROBADO_EXITO'));
        metodo.codigoEstado = EstadosMetodosMedios.METODOACTIVO;
        metodo.estado = 'ACTIVO';
        metodo.codigoEstadoMetodo = EstadosMetodosMedios.METODOACTIVO;
        metodo.estadoMetodo = 'ACTIVO';
        metodo.indicadorHabilitado = true;
        metodo.idAdjuntoCertificadoRegistro = idAdjuntoCert;
        this.cerrarModalAprobacion();
        this.cargarArbol(this.idTitular);
      },
      error: () => {
        this.guardandoAprobacion = false;
        this.navService.setMesage(3);
      }
    });
  }

  // HU #5354 (3. CAMBIOS EN DESARROLLO): Visualización del documento usado para habilitación
  obtenerDocumentoHabilitacion(metodo?: AdmsbMetodoNodo): TerceroUPPasarelaAdjunto | null {
    if (!metodo || !metodo.idAdjuntoCertificadoRegistro) return null;
    const defaultNombre = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO');
    return this.crearAdjuntoDesdeId(metodo.idAdjuntoCertificadoRegistro, metodo.nombreMetodo || defaultNombre);
  }

  tieneDocumentoHabilitacion(metodo?: AdmsbMetodoNodo): boolean {
    return !!this.obtenerDocumentoHabilitacion(metodo);
  }

  verDocumentoHabilitacion(metodo?: AdmsbMetodoNodo): void {
    const doc = this.obtenerDocumentoHabilitacion(metodo);
    if (doc) {
      this.verAdjunto(doc);
    }
  }

  obtenerDocumentoHabilitacionMedio(medio: AdmsbMedioFila, metodo?: AdmsbMetodoNodo): TerceroUPPasarelaAdjunto | null {
    if (!medio || !medio.idAdjuntoCertificadoRegistro) return null;
    const defaultNombre = this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO');
    return this.crearAdjuntoDesdeId(medio.idAdjuntoCertificadoRegistro, medio.nombreMedio || medio.nombreMedioPago || defaultNombre);
  }

  tieneDocumentoHabilitacionMedio(medio: AdmsbMedioFila, metodo?: AdmsbMetodoNodo): boolean {
    return !!this.obtenerDocumentoHabilitacionMedio(medio, metodo);
  }

  verDocumentoHabilitacionMedio(medio: AdmsbMedioFila, metodo?: AdmsbMetodoNodo): void {
    const doc = this.obtenerDocumentoHabilitacionMedio(medio, metodo);
    if (doc) {
      this.verAdjunto(doc);
    }
  }

  cambioTarifas(medio: AdmsbMedioFila, metodo: AdmsbMetodoNodo): void {
    // HU #5353: Apertura del sidebar lateral de tarifas preferenciales
    if (!medio) {
      return;
    }
    this.medioTarifasSeleccionado = medio;
    this.metodoTarifasSeleccionado = metodo;
    this.mostrarSidebarTarifas = true;
  }

  onTarifaGuardada(event: { respuesta: TerceroUPPasarelaTarifa; medio: AdmsbMedioFila }): void {
    this.cargarArbol(this.idTitular);
  }

  // ---- Filtros locales ----
  filtrarContratosMetodo(metodo: AdmsbMetodoNodo): TerceroUPPasarelaContrato[] {
    const texto = (metodo?.filtroContratos || '').trim();
    if (!texto) {
      return metodo?.contratos || [];
    }
    const meta = metodo as any;
    if (meta._ultimoFiltroCon === texto && meta._contratosCache) {
      return meta._contratosCache;
    }
    const filtrados = filtrarPorTexto(metodo.contratos || [], texto, [
      c => c.nombrePlantilla,
      c => c.fechaFirma
    ]);
    meta._ultimoFiltroCon = texto;
    meta._contratosCache = filtrados;
    return filtrados;
  }

  // ---- Lógica de Adjuntos ----
  estaCargandoAdjunto(adjunto: TerceroUPPasarelaAdjunto): boolean {
    return !!adjunto?.idDocumentoTercero && this.adjuntosCargando.has(adjunto.idDocumentoTercero);
  }

  onSelectAdjunto(files: File[], adjunto: TerceroUPPasarelaAdjunto): void {
    this.adjuntosCargando.add(adjunto.idDocumentoTercero);
    this.nomArchivoAdjunto = files[0]?.name ?? '';
  }

  onBeforeSendAdjunto(event: any): void {
    this.subAdjunto = true;
    this.adjService.cargarArchivo(event, this.nomArchivoAdjunto, 'AdmsbTitularAdjuntos');
  }

  onUploadAdjunto(event: any, adjunto: TerceroUPPasarelaAdjunto): void {
    const idAdjunto = event?.originalEvent?.body?.idAdjunto;
    if (!idAdjunto) {
      this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
      this.subAdjunto = false;
      return;
    }
    const registro = this.construirRegistroAdjunto(adjunto, idAdjunto);
    this.terceroUpPasarelaAdjuntoServicio.crearAdjuntoVersion(registro).subscribe({
      next: () => {
        this.navService.setMesage(2);
        if (adjunto) {
          adjunto.idAdjunto = idAdjunto;
        }
        if (this.certificadoParaAprobacion && this.certificadoParaAprobacion.idDocumentoTercero === adjunto?.idDocumentoTercero) {
          this.certificadoParaAprobacion.idAdjunto = idAdjunto;
        }
        this.cargarArbol(this.idTitular);
        this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
        this.subAdjunto = false;
        if (this.showModalAdjunto) {
          this.verAdjunto({ ...adjunto, idAdjunto });
        }
      },
      error: () => {
        this.navService.setMesage(3);
        this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
        this.subAdjunto = false;
      }
    });
  }

  verAdjunto(adjunto: TerceroUPPasarelaAdjunto): void {
    if (!adjunto || !adjunto.idAdjunto) {
      return;
    }
    this.adjuntoVisor = adjunto;
    this.loadingFile = true;
    this.showModalAdjunto = true;
    forkJoin([
      this.adjService.descargarArchivo(adjunto.idAdjunto, !!adjunto.indicadorTercero),
      this.adjService.obtenerAdjunto(adjunto.idAdjunto, !!adjunto.indicadorTercero).pipe(
        catchError(() => of({ nombreArchivo: adjunto.nombre || 'Certificado_Registro' } as any))
      )
    ]).subscribe({
      next: ([archivo, infoAdjunto]) => {
        this.archivoAdjuntoVisor = archivo;
        this.nombreArchivoAdjuntoVisor = infoAdjunto?.nombreArchivo || adjunto.nombre || 'archivo';
        if (archivo && (archivo instanceof Blob) && archivo.size > 0) {
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(archivo));
        }
        this.loadingFile = false;
      },
      error: () => {
        this.loadingFile = false;
      }
    });
  }

  descargarArchivo(): void {
    if (!this.archivoAdjuntoVisor) return;
    saveAs(this.archivoAdjuntoVisor, this.nombreArchivoAdjuntoVisor || 'archivo');
  }

  cerrarModalAdjunto(): void {
    this.showModalAdjunto = false;
    this.fileUrl = null;
    this.archivoAdjuntoVisor = null;
    this.nombreArchivoAdjuntoVisor = '';
    this.adjuntoVisor = null;
  }

  onAdjuntosActualizados(adjuntos: TerceroUPPasarelaAdjunto[], metodo?: AdmsbMetodoNodo): void {
    if (metodo) {
      metodo.adjuntos = adjuntos;
    }
  }

  private construirRegistroAdjunto(
    base: Pick<TerceroUPPasarelaAdjunto, 'idDocumentoTercero' | 'codigo' | 'nombre' | 'codigoTipoVigencia' |
      'tipoVigencia' | 'indicadorSolicitarCliente' | 'orden'> &
      Partial<Pick<TerceroUPPasarelaAdjunto, 'idTerceroUPPasarelaAdjunto' | 'idTercerosUPPasarelasAdjuntosVersion'>>,
    idAdjunto: string | null,
    indicadorHabilitado = true
  ): Partial<TerceroUPPasarelaAdjunto> & { idtercerosUPPasarelasAdjuntos?: string; indicadorHabilitado?: boolean } {
    return {
      idTerceroUPPasarela: this.idTitular,
      idTerceroUPPasarelaAdjunto: base.idTerceroUPPasarelaAdjunto,
      idTercerosUPPasarelasAdjuntosVersion: base.idTercerosUPPasarelasAdjuntosVersion,
      idDocumentoTercero: base.idDocumentoTercero,
      codigo: base.codigo,
      nombre: base.nombre,
      codigoTipoVigencia: base.codigoTipoVigencia,
      tipoVigencia: base.tipoVigencia,
      indicadorSolicitarCliente: base.indicadorSolicitarCliente,
      orden: base.orden,
      idAdjunto,
      indicadorHabilitado
    };
  }

  // ---- Lógica de Contratos ----
  previsualizarContrato(contrato: TerceroUPPasarelaContrato): void {
    this.contenidoContrato = null;
    this.mostrarModalContrato = true;
    if (contrato.idPlantillaVersion) {
      this.plantillaVersionServicio.obtenerPorId(contrato.idPlantillaVersion).subscribe(res => {
        this.contenidoContrato = this.sanitizer.bypassSecurityTrustHtml(res.cuerpo);
      });
    } else if (contrato.idPlantilla) {
      this.plantillaServicio.getById(contrato.idPlantilla).subscribe(res => {
        this.contenidoContrato = this.sanitizer.bypassSecurityTrustHtml(res.cuerpo);
      });
    }
  }

  cerrarModalContrato(): void {
    this.mostrarModalContrato = false;
    this.contenidoContrato = null;
  }
}
